{
  "page_count": "od {n, plural, one{# strana} other{# strana}}"
}
